// ─────────────────────────────────────────────────────────────────────────
//  ClickViewer · web · 404
//
//  ★★★ 이 화면은 **한 종류뿐이다.** ★★★
//
//  아래 넷이 전부 이 화면이어야 한다. 하나라도 다르게 보이면 그 차이가 곧
//  "그 현장은 존재한다" 는 확인이 된다(DB-DESIGN §7-5).
//
//    · 없는 주소            · 내 현장이 아닌 현장
//    · 삭제된 현장          · 아직 안 만든 화면의 주소
//
//  ⚠️ 그래서 이 컴포넌트는 **인자를 받지 않는다.** 받을 수 있게 만들면 언젠가 누가
//     "친절하게" 사유를 넣는다("권한이 없습니다", "삭제된 현장입니다"). 그 순간 설계가 깨진다.
//     apps/api/src/errors.ts 의 notFound() 가 인자를 안 받는 것과 같은 이유다.
//
//  ⚠️ 서버의 404 는 본문·헤더가 **바이트 단위로 같다.** 화면도 그래야 의미가 있다 —
//     한쪽만 지키면 공격자는 화면 문구가 아니라 응답을 보면 된다. 둘 다 지켜야 한다.
//
//  ★ 그렇다고 막다른 길로 두지는 않는다. **다음 행동 둘**을 준다:
//    목록으로 돌아가기 / 초대 메일의 링크로 다시 들어오기. 그리고 연락처.
// ─────────────────────────────────────────────────────────────────────────

import { Card, Stack, Text, Title } from '@mantine/core';
import { Contact } from '../components/Contact';
import { CenteredShell } from '../components/Shell';
import { PrimaryButton } from '../components/Actions';
import { navigate } from '../router';

export function NotFound() {
  return (
    <CenteredShell>
      <Stack gap="lg" mt="lg">
        <Card padding="lg">
          <Stack gap="md" className="cv-measure">
            <Title order={1}>찾을 수 없는 주소입니다</Title>

            {/* 16px · ink-2. 막힌 사람이 읽어야 하는 유일한 설명이다 — 흐리게 두지 않는다. */}
            <Text size="md" c="var(--cv-ink-2)">
              주소가 잘못되었거나, <b>이 계정으로는 볼 수 없는 곳</b>입니다.
            </Text>
            <Text size="md" c="var(--cv-ink-2)">
              초대를 받으셨다면 <b>초대 메일의 링크</b>로 들어와야 합니다. 그리고 초대장이 온
              주소와 지금 로그인한 주소가 같아야 합니다 — 지금 주소는 오른쪽 위
              「내 계정」에서 확인할 수 있습니다.
            </Text>

            <PrimaryButton onClick={() => navigate('/')}>내 현장 목록으로</PrimaryButton>
          </Stack>
        </Card>

        <Contact subject="[ClickView] 열리지 않는 주소 문의" />
      </Stack>
    </CenteredShell>
  );
}
